// Mock data for LTechSolutions website

export const whatsappNumber = "+59898993134";
export const whatsappMessage = "Hola, estoy interesado en crear una página web para mi negocio";

export const services = [
  {
    id: 1,
    title: "Creación de páginas web modernas",
    description: "Diseñamos y desarrollamos sitios web profesionales adaptados a tu negocio, con tecnología actual y diseño responsive.",
    icon: "Globe"
  },
  {
    id: 2,
    title: "Diseño optimizado para celulares",
    description: "El 80% de tus clientes navegan desde el móvil. Nos aseguramos de que tu web se vea perfecta en todos los dispositivos.",
    icon: "Smartphone"
  },
  {
    id: 3,
    title: "Integración con WhatsApp",
    description: "Conecta directamente con tus clientes. Implementamos botones de contacto directo para que te escriban fácilmente.",
    icon: "MessageCircle"
  },
  {
    id: 4,
    title: "Menús digitales para restaurantes",
    description: "Menús interactivos, actualizables y atractivos. Tus clientes verán tus platillos con imágenes y precios actualizados.",
    icon: "UtensilsCrossed"
  },
  {
    id: 5,
    title: "Optimización para buscadores (SEO)",
    description: "Hacemos que tu negocio aparezca en Google cuando tus clientes buscan servicios como el tuyo en tu zona.",
    icon: "Search"
  },
  {
    id: 6,
    title: "Soporte y mantenimiento",
    description: "No te dejamos solo. Te ayudamos a mantener tu sitio actualizado y resolver cualquier duda que tengas.",
    icon: "Headphones"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Analizamos tu negocio",
    description: "Conocemos tu marca, tus objetivos y qué quieres transmitir a tus clientes.",
    icon: "Search"
  },
  {
    id: 2,
    title: "Diseñamos tu página web",
    description: "Creamos un diseño único y profesional que refleja la identidad de tu negocio.",
    icon: "Palette"
  },
  {
    id: 3,
    title: "Publicamos tu sitio online",
    description: "Llevamos tu web a internet con hosting rápido y seguro, lista para recibir visitas.",
    icon: "Rocket"
  },
  {
    id: 4,
    title: "Te ayudamos a mantenerlo actualizado",
    description: "Te brindamos soporte continuo y te enseñamos a gestionar tu contenido fácilmente.",
    icon: "RefreshCw"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Mayor visibilidad en internet",
    description: "Aparece en Google cuando clientes buscan negocios como el tuyo.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Más clientes encontrando tu negocio",
    description: "Las personas buscan online antes de decidir. Captura esos clientes.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Imagen más profesional",
    description: "Una web moderna transmite confianza y profesionalismo a tus clientes.",
    icon: "Award"
  },
  {
    id: 4,
    title: "Acceso rápido al menú o servicios",
    description: "Tus clientes ven tu oferta completa sin tener que llamar o visitar.",
    icon: "Menu"
  },
  {
    id: 5,
    title: "Contacto directo con clientes",
    description: "WhatsApp integrado para que te contacten con un solo clic.",
    icon: "PhoneCall"
  },
  {
    id: 6,
    title: "Disponible 24/7",
    description: "Tu negocio visible todo el tiempo, incluso cuando estás cerrado.",
    icon: "Clock"
  }
];

export const portfolioItems = [
  {
    id: 1,
    category: "Local Gastronómico",
    title: "Poke&Co",
    description: "Sitio web moderno para local de poke bowls con menú digital y pedidos online",
    url: "https://www.pokeandco.uy",
    desktopImage: "/portfolio/pokeandco_desktop.jpg",
    mobileImage: "/portfolio/pokeandco_mobile.jpg",
    isDemo: false
  },
  {
    id: 2,
    category: "Pizzería",
    title: "The Pizza House Melo",
    description: "Página web profesional para pizzería con menú completo, pedidos y ubicación",
    url: "https://the-pizza-house-melo.vercel.app/",
    desktopImage: "/portfolio/pizzahouse_desktop.jpg",
    mobileImage: "/portfolio/pizzahouse_mobile.jpg",
    isDemo: false
  },
  {
    id: 3,
    category: "Club Deportivo",
    title: "Tie Break Padel Club",
    description: "Plataforma web para club de pádel con sistema de reservas y tienda online",
    url: "https://club-deportivo-six.vercel.app/",
    desktopImage: "/portfolio/clubdeportivo_desktop.jpg",
    mobileImage: "/portfolio/clubdeportivo_mobile.jpg",
    isDemo: true
  },
  {
    id: 4,
    category: "E-commerce",
    title: "Punta Tech Club",
    description: "Tienda online completa con catálogo de productos, carrito de compras y sistema de pagos",
    url: "https://e-commerce-demo-3.vercel.app/",
    desktopImage: "/portfolio/ecommerce_desktop.jpg",
    mobileImage: "/portfolio/ecommerce_mobile.jpg",
    isDemo: true
  }
];

export const socialLinks = [
  { name: "Instagram", icon: "Instagram", url: "#" },
  { name: "Facebook", icon: "Facebook", url: "#" },
  { name: "LinkedIn", icon: "Linkedin", url: "#" }
];
